export default __webpack_public_path__ + "static/media/dark.2211f099.svg";